<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <Header :drawer="$store.state.drawer"></Header>
    <Sidebar :drawer="$store.state.drawer"></Sidebar>
    <v-content>
      <v-container class="main-right">
        <v-card-title>VUNET Application Preview </v-card-title>
        <!-- style="background-color:#e8e8e8!important" -->
        <!-- {{lapplication}} -->
        <v-row>
          <v-col
            cols="12"
            sm="4"
            md="4"
            v-for="(lapp, index) in lapplication"
            :key="index"
          >
            <v-card class="card-payess">
              <div class="card-head-title">Application Number</div>
              <div class="card-head12">{{ lapp.application_number }}</div>
              <div class="card-head-title pt-3">Programme Name</div>
              <div class="card-head12 pgm-no">{{ lapp.program }}</div>

              <v-row >
                <v-col cols="12" sm="12" md="12">
                  <div class="card-head-title pt-3">Application Date</div>
                  <div class="card-head121">{{ lapp.application_date }}</div>
                </v-col>
               
              </v-row>
              <row>
                 <v-col cols="12" sm="12" md="12" class="ml-n3">
                  <div class="card-head-title ">Exam Date</div>
                  <div class="card-head121">{{ lapp.examdate }}</div>
                </v-col>
              </row>
              <v-row class="margin-top:-10px !important;">
                <!-- <v-col cols="12" sm="6" md="6">
                                    <div class="card-head-title"> Fees Status</div>
                                    <div class="card-head12" style="color: #15c322;">{{lapp.examfees_paid}}</div>
                                </v-col> -->
                <v-col cols="12" sm="5" md="5">
                  <div class="card-head-title">Application Preview</div>
                  <div class="card-head12">
                    <v-icon
                      dark
                      left
                      style="font-size: 20px; color: #f05a2b"
                      title="view/Download"
                      @click="onButtonClick(lapp)"
                    >
                      mdi-eye
                    </v-icon>
                  </div>
                </v-col>
                <v-col cols="12" sm="7" md="7">
                  <div class="card-head-title">Edit Application Form</div>
                  <div class="card-head12">
                    <v-btn
                      color="#F05A2B"
                      dark
                      outlined
                      @click="editApplication(lapp)"
                    >
                      EDIT
                    </v-btn>
                  </div>
                </v-col>
                <!-- <v-col cols="12" sm="6" md="6">
                                    <div class="card-head-title">Exam Fees</div>
                                      <div class="card-head12" style="color: #15c322;">{{lapp.examfees}}</div>
                               
                                </v-col> -->
              </v-row>
              <v-row class="margin-top:0px !important;">
                <!-- <v-col cols="12" sm="6" md="6">
                                    <div class="card-head-title">Fees Status</div>
                                    <div v-if="lapp.examfees_paid== 'Paid'" class="card-head12">
                                        <v-btn color="#F05A2B" dark @click="getTransactionDetails(lapp)">VIEW RECEIPT</v-btn>
                                    </div>
                                    <div v-else class="card-head12">
                                        <v-btn color="red" style="font-weight: 16px;" dark @click="payfees(lapp)">
                                            <v-icon dark left style="font-size: 20px;">
                                                mdi-bookmark-remove
                                            </v-icon>

                                            Pay Fees
                                        </v-btn>
                                    </div>
                                </v-col> -->

                <!-- <v-col cols="12" sm="6" md="6">
                                    <div class="card-head-title">Application Preview</div>
                                    <div class="card-head12">
                                        <v-btn color="#F05A2B" dark outlined   @click="editApplication(lapp)">
                                            EDIT
                                        </v-btn>
                                    </div>
                                </v-col> -->
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import Header from "../shared/Header";
import Sidebar from "../shared/Sidebar";

export default {
  components: {
    Header: Header,
    Sidebar: Sidebar,
  },
  data: (vm) => ({
    overlay: false,
    snackbar_msg: "",
    snackbar: false,
    color: "",
    org: null,
    headers: [
      { text: "Application Number", value: "application_number" },
      { text: "Program/Course", value: "program" },
      { text: "Application Date", value: "application_date" },
      { text: "Exam Date", value: "examdate" },
      { text: "Application Preview", value: "" },
      { text: "Is VUNET Fees Paid?", value: "examfees_paid" },
      { text: "Edit", value: "edit" },
    ],
    lapplication: [],
  }),
  watch: {
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  computed: {},
  methods: {
    onButtonClick(item) {
      this.$router.push({
        path: "/student/application-preview",
        query: { item: item },
      });
    },
    payfees(item) {
      this.$router.push({
        path: "/student/student-application-fees-form",
        query: { item: item },
      });
    },
    getTransactionDetails(item) {
      this.$router.push({
        path: "/student/application-form-fees-receipt",
        query: { item: item },
      });
    },
    editApplication(item) {
      this.$router.push({
        path: "/student/application-edit",
        query: { item: item },
      });
    },
  },
  mounted() {
    // //user selection none code
    //       $(document).ready(function() {
    //       $(window).on("contextmenu",function(e){
    //         return false;
    //       });
    //   });
    //   document.onkeydown = function (e) {
    //       e = e || window.event;//Get event
    //       if (e.ctrlKey) {
    //           var c = e.which || e.keyCode;//Get key code
    //           switch (c) {
    //               case 83://Block Ctrl+S
    //               case 87://Block Ctrl+W --Not work in Chrome
    //               case 73://Block Ctrl+I
    //               case 67: //Block Ctrl+C
    //                   e.preventDefault();
    //                   e.stopPropagation();
    //               break;
    //           }
    //       }
    //   };
    this.overlay = true;
    axios
      .post("/Student/studentApplicationInformation")
      .then((res) => {
        if (res.data.msg == "200") {
          this.overlay = false;
          this.lapplication = res.data.lapplication;
        }
      })
      .catch((error) => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      })
      .finally(() => {
        this.overlay = false;
      });
  },
};
/*
1.
<span style="opacity:1" v-html="opt.option_value"></span>

2.
import {VueMathjax} from 'vue-mathjax'
import MathLive from 'mathlive'
export default {
  components: {
    'vue-mathjax': VueMathjax
  },

3.
updated: function () {	
        console.log("Inside updated");
        this.$nextTick(function () {
    MathLive.renderMathInDocument();	
  })
	},
*/
</script>
<style scoped>
.pgm-no {
  width: 15em; /* the element needs a fixed width (in px, em, %, etc) */
  overflow: hidden; /* make sure it hides the content that overflows */
  white-space: nowrap; /* don't break the line */
  text-overflow: ellipsis; /* give the beautiful '...' effect */
  cursor: pointer;
}
.pgm-no:hover {
  overflow: visible;
  white-space: normal;
  cursor: pointer;
}
.main-div {
  user-select: none;
}
.card-head12 {
  text-align: left;
  font: normal normal medium 18px/22px Roboto !important;
  letter-spacing: 0px;
  font-size: 18px;
  color: #212529;
  font-weight: 500;
}
 .card-head121 {
        text-align: left;
        font: normal normal medium 18px/22px Roboto !important;
        letter-spacing: 0px;
        font-size: 18px;
        color: #212529;
        font-weight: 500;
    }
.card-head-title {
  text-align: left;
  font-size: 12px;
  font: normal normal medium 12px/14px Roboto !important;
  letter-spacing: 0px;
  color: #212529;
  font-weight: 500;
}
.card-payess {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #c4c4c4;
  padding: 2rem 2rem 2rem 2rem;
}
.mytable /deep/ thead th {
  color: rgb(0, 0, 0) !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
body {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
th {
  vertical-align: top;
}
.btn-download-receipt1 {
  font-weight: 16px;
  background: linear-gradient(
    130deg,
    hsla(190, 99%, 30%, 1) 0%,
    hsla(226, 50%, 65%, 1) 180%
  );
  border-color: #3f51b5 !important;
  color: white;
  border-radius: 2px;
  padding: 2px 5px;
}
.btn-download-receipt {
  font-weight: 16px;
  background: linear-gradient(
    130deg,
    hsla(190, 99%, 30%, 1) 0%,
    hsla(226, 50%, 65%, 1) 180%
  );
  border-color: #3f51b5 !important;
  color: white;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 32px;

  padding: 0 10px;
}
</style>
